import React from 'react'
import CustomModal from '../../baseComponents/gui/customModal/CustomModal'
import CustomButton from '../../features/customButton/ui/main/CustomButton'
import classNames from 'classnames'
import { safeHTML } from '../../../utils/safeHTML'
import { useModal } from '../../../hooks/useModal'
import { useTranslation } from '../../../translations'

const OnboardingModal = React.forwardRef(function OnboardingModal(
  {
    id: modalId,
    image,
    title,
    description,
    buttons,
    redirect,
    closeCallback,
    onClose,
    callbacks = {},
    textContainerSize = 'default',
    buttonsMarginSize = 'default',
  },
  ref,
) {
  const { id, closeModal } = useModal()
  const { t } = useTranslation()

  const buttonCallbacks = {
    close() {
      closeModal({ id })
      onClose?.()
      closeCallback?.()
    },
  }

  return (
    <CustomModal>
      <div
        className={classNames(`onboarding-modal`)}
        ref={ref}
      >
        <div className={classNames('onboarding-modal__content')}>
          {image && (
            <div className='onboarding-modal__image'>
              <img
                src={image}
                alt={title || ''}
              />
            </div>
          )}

          <div
            className={classNames(
              'onboarding-modal__text-container',
              `margin-${textContainerSize}`,
            )}
          >
            {title && <h2 className='onboarding-modal__title'>{safeHTML(t(title))}</h2>}

            {description && (
              <div className='onboarding-modal__text'>{safeHTML(t(description))}</div>
            )}

            <div className={classNames('onboarding-modal__buttons', `margin-${buttonsMarginSize}`)}>
              {buttons.map((button, index) => (
                <CustomButton
                  key={index}
                  {...button.attr}
                  onClick={() => buttonCallbacks[button.action]?.(button)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  )
})

export default OnboardingModal
OnboardingModal.propTypes = {}
OnboardingModal.displayName = 'OnboardingModal'
